import './Datepicker.scss';
import React from 'react';
import * as moment from 'moment';
import { DatePicker, Icon } from 'antd';
import { FormattedDate } from 'react-intl';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IFormattedText {
  displayName: string;
  formattedName: string;
};

interface IProps {
  locale: string;
  defaultDate: Date;
  placeholder: IFormattedText;
  triggerStyle: string;
  onDateClick: (date: Date) => void;
}

interface IState {
  isCalendarVisible: boolean;
  isClearIconVisible: boolean;
}

class Datepicker extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isCalendarVisible: false,
      isClearIconVisible: false,
    }
  }

  clearDate = (e: any) => {
    e.stopPropagation();
    this.props.onDateClick(null);
    this.setState({ 
      isClearIconVisible: false, 
      isCalendarVisible: false,
    });
  }

  onChange = (m: moment.Moment) => {
    this.setState({ isCalendarVisible: false });
    this.props.onDateClick(m ? m.startOf('day').toDate() : null);
  }

  toggleCalendar = () => {
    const isCalendarVisible = !this.state.isCalendarVisible;
    this.setState({ isCalendarVisible });
  };

  handleOutsideClick = () => {
    this.setState({ isCalendarVisible: false });
  }

  render() {

    const { 
      locale, 
      defaultDate,
      placeholder,
      triggerStyle,
    } = this.props;

    const { isCalendarVisible } = this.state;
    const caret = isCalendarVisible ? 'caret-up' : 'caret-down';
    const defaultMoment = defaultDate ? moment(defaultDate).locale(locale) : null;

    return (
      <div className='date-picker'>
        <div className={ triggerStyle } onClick={ this.toggleCalendar }>
          <Icon type='calendar'/>
          { defaultDate ? 
            <>
              <FormattedDate value={ defaultDate } month='long' day='numeric' year='numeric' />
              <Icon type='close' onClick={ this.clearDate }/>
            </> :
            <>
              <FormattedText style='placeholder' { ...placeholder } />
              <Icon type={ caret } />
            </>
          }
        </div>
        <DatePicker 
          className='datepicker-input'
          showToday={ false }
          dropdownClassName='datepicker-dropdown'
          onChange={ this.onChange } 
          open={ isCalendarVisible }
          value={ defaultMoment }
        />
      </div>
    );
  }
}

export default Datepicker;


// WEBPACK FOOTER //
// ./src/components/Shared/Datepicker/Datepicker.tsx